import { useDispatch } from "react-redux";
import { Card, CardContent } from "@/components/ui/library/card";
import { ChildDetailsHeader } from "@/module/education/nicheSideRoutes/components/education-details/ChildDetailsHeader";
import { Separator } from "@/components/ui/separator";
import AcademyChoiceInfo from "./AcademyChoiceInfo";
import StatusSection from "@/module/education/nicheSideRoutes/components/education-details/StatusSection";
import DocumentSection from "@/module/education/nicheSideRoutes/components/education-details/DocumentSection";
import AssingnedUsers from "@/module/education/nicheSideRoutes/components/education-details/AssingnedUsers";
import { CollabedBadge } from "@/module/components/components";
import {
  setCurrentDetailChild,
  setIsStageViewOverride,
} from "@/features/leads/stores/childSlice";
import { useAppSelector } from "@/stores/hook";

export default function AcademyChildDetails() {
  const dispatch = useDispatch();
  const { currentDetailChild } = useAppSelector(
    (state) => state.childFunctional
  );

  const handleBackClick = () => {
    dispatch(setIsStageViewOverride(false));
    dispatch(setCurrentDetailChild({}));
  };

  return (
    <Card className="border-[var(--color-black-1)] rounded-[16px] shadow-none py-0 relative">
      <CardContent className="px-4 py-4 gap-4 flex flex-col">
        <ChildDetailsHeader
          childName={(currentDetailChild as any)?.name}
          onBackClick={handleBackClick}
        />
        <Separator />

        <AcademyChoiceInfo child={currentDetailChild as any} />
        <StatusSection child={currentDetailChild as any} />
        <DocumentSection />
        <AssingnedUsers child={currentDetailChild as any} />
      </CardContent>

      <CollabedBadge position="right" />
    </Card>
  );
}
